import type { FC } from 'react';

interface Props {
  withAnchorList?: boolean;
}

export const MobileSubHeader: FC<Props> = () => null;
// const { subHeadingText } = useHeadingTexts();

// if (!withAnchorList && !subHeadingText) {
//   return null;
// }

// return (
//   <div className={styles.overlay}>
//     <div className={styles.container}>
//       {/* {subHeadingText && <p className={styles.subheading}>{subHeadingText}</p>} */}
//       {withAnchorList && <AnchorLinkList />}
//     </div>
//   </div>
// );
